// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import QRCode from 'qrcode'

import router from './router'
import qs from 'qs';

import axios from 'axios';
import store from './store';
import ElementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import 'jquery/dist/jquery.min.js'
// import 'bootstrap/dist/css/bootstrap.css'


import MetaInfo from 'vue-meta-info'

import datm from '../static/data.js';
import * as all from '../static/all.js';
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
// 设置请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 设置响应拦截器
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response
  }, error => {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

//二维码
function useqrcode(url, param,w,h) {
  let str = ''
  if (all.notEmpty(param)) {
    str = '?' + all.converToUrl(param)
  }
  setTimeout(() => {
    let canvas = document.getElementById("QRCode_header");
    let obj = {
      errorCorrectionLevel: "H", //容错级别
      type: "image/png", //生成的二维码类型
      quality: 0.3, //二维码质量
      margin: 3, //二维码留白边距
      width: w, //宽
      height: h, //高
      color: {
        dark: "#333333", //前景色
        light: "#fff" //背景色
      }
    }
    QRCode.toCanvas(canvas, `https://www.jumugongli.com/${url}${str}`, obj)
  }, 100)
}


function goTop() {
  var myTimer = -1;
  //1、获取当前滚动了多少距离
  //2、启动定时器，以一定时间减少响应的滚动距离
  var scrollTo = document.documentElement.scrollTop || document.body.scrollTop
  if (myTimer = -1) {
    myTimer = setInterval(() => {
      scrollTo -= 60
      if (scrollTo <= 0) {
        scrollTo = 0
        window.clearInterval(myTimer)
        myTimer = -1
      }
      window.scrollTo(0, scrollTo) //这是值  是指离开网页顶部的距离
    }, 10);
  }
}
// 发送请求
Vue.prototype.$request = (type, url, data, success, error) => {
  const headers = {
  },
    typeArr = [],
    typeFun = type + '()';
  const post = () => axios.post(url, data, {
      headers: headers
    }).then(success).catch(error),
    get = () => axios.get(url, {
      params: data,
      headers: headers
    }).then(success).catch(error),
    put = () => axios.put(url, data, {
      headers: headers
    }).then(success).catch(error),
    del = () => axios.delete(url, {
      params: data,
      headers: headers
    }).then(success).catch(error),
    patch = () => axios.patch(url, data, {
      headers: headers
    }).then(success).catch(error);
  eval(typeFun)
}

Vue.config.productionTip = false
Vue.prototype.datms = datm
Vue.prototype.$all = all
Vue.prototype.$wxapi = store.state.offlineUrl
Vue.prototype.$otapi = store.state.otherlineUrl
Vue.prototype.$imgUrl = store.state.imgUrl
Vue.prototype.useqrcode = useqrcode
Vue.prototype.goTop = goTop
Vue.prototype.$store = store
Vue.prototype.$wow = wow

/* eslint-disable no-new */


Vue.use(MetaInfo)

Vue.use(ElementUi)
new Vue({
  router,
  render: h => h(App),
  mounted() {
    setTimeout(()=>{
       document.dispatchEvent(new Event('render-event'))
    },10000)
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js